import React, { useState, useEffect } from 'react';
import { Card, Collapse, Row, Col, Select, Input, Button } from 'antd';
import axios from '../util/axiosConfig';
import { useLocation } from 'react-router-dom';
import LineItemEditTable from './Tables/LineItemEditTable';
import '../styles/reports.css';
import { useInvContext } from '../context/InvContext';
import AuditLog from '../pages/auditLog';
const { Option } = Select;

const ModificationLog: React.FC = () => {
    const { isAdmin } = useInvContext();
    const location = useLocation();
    const [panelData, setPanelData] = useState<any>(null);

    const [disputeReasons, setDisputeReasons] = useState<string[]>([]);
    const [isEditable, setIsEditable] = useState(false);
    const [isShowRemarks, setIsShowRemarks] = useState(false);
    const [selectedDisputeReason, setSelectedDisputeReason] = useState<number | undefined>(undefined);

    const [invoiceData, setInvoiceData] = useState<any>({});

    const fetchInvoiceData = async (id: number) => {
        try {
            const response = await axios.get(`/get-invoice-dto`, {
                params: {
                    invoiceId: id
                },
            });
            if (response?.data) {
                setInvoiceData(response?.data?.data);
            }
        } catch (error) {
            console.error('Failed to fetch invoice data:', error);
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const data = Object.fromEntries(urlParams.entries());
        setPanelData(data);
        const fetchDisputeReasons = async () => {
            try {
                const response = await axios.get('/dispute-reason/list');
                if (response?.data?.data) {
                    setDisputeReasons(response.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch dispute reasons:', error);
            }
        };

        if (panelData?.id) {
            fetchInvoiceData(panelData.id);
        }
        fetchDisputeReasons();
        // eslint-disable-next-line
    }, [panelData?.id]);

    const handleDisputeReasonChange = (value: any) => {
        if (value === 1 || value === 2 || value === 4) {
            setIsEditable(true);
            setIsShowRemarks(false);
        } else if (value === 3) {
            setIsEditable(false);
            setIsShowRemarks(true);
        } else {
            setIsEditable(false);
            setIsShowRemarks(false);
        }
        setSelectedDisputeReason(value);
    };

    const resetDisputeReason = async (finalRemarks: any) => {
        try {
            const payload = {
                invoicePageableDto: {
                    id: panelData?.id || 0,
                    reference: invoiceData.reference || '',
                    subject: invoiceData.subject || '',
                    invoiceReference: invoiceData.invoiceReference || '',
                    companyReference: invoiceData.companyReference || '',
                    currencyCode: invoiceData.currencyCode || '',
                    cfPostingDate: invoiceData.cfPostingDate || '',
                    invoiceDate: invoiceData.invoiceDate || '',
                    billingAddressReference: invoiceData.billingAddressReference || '',
                    subTotal: invoiceData.subTotal || 0,
                    poDate: invoiceData.poDate || '',
                    poNumber: invoiceData.poNumber || '',
                    status: invoiceData.status || '',
                    vendorName: invoiceData.vendorName || '',
                    taxableValue: invoiceData.taxableValue || 0,
                    taxAmount: parseFloat(invoiceData.taxAmount) || 0,
                    totalAmount: parseFloat(invoiceData.totalAmount) || 0,
                    fileDetailsId: invoiceData.fileDetailsId || 0,
                    s3Url: invoiceData.s3Url || '',
                    rejectionRemark: finalRemarks || invoiceData.rejectionRemark || ''
                },
                lineItemPageableDtos: []
            };

            await axios.post('/update-invoice', payload);
            if (panelData?.id) {
                fetchInvoiceData(panelData.id);
            }
        } catch (error) {
            console.error('Failed to update invoice:', error);
        }

        setSelectedDisputeReason(undefined);
        handleDisputeReasonChange(null);
    };

    const renderPanelHeader = () => (
        <>
            <Row>
                <Col span={24} className='align-center-div'>
                    <Row className="header-list-row" style={{ width: '100%' }}>
                        <Col span={4}>
                            <p className='panel-head-txt'>Invoice No</p>
                                <p className='panel-text'>{invoiceData?.invoiceReference || '-'}</p>
                        </Col>
                        <Col span={5}>
                            <p className='panel-head-txt'>Vendor Name</p>
                                <p className='panel-text'>{invoiceData?.vendorName || '-'}</p>
                        </Col>
                        <Col span={3}>
                            <p className='panel-head-txt'>PO Number</p>
                                <p className='panel-text'>{invoiceData?.poNumber || '-'}</p>
                        </Col>
                        <Col span={2}>
                            <p className='panel-head-txt'>Tax Amount</p>
                                <p className='panel-text'>{invoiceData?.taxAmount || '-'}</p>
                        </Col>
                        <Col span={3}>
                            <p className='panel-head-txt'>Total Amount</p>
                                <p className='panel-text'>{invoiceData?.totalAmount || '-'}</p>
                        </Col>
                        <Col span={5}>
                            <p className='panel-head-txt'>Status</p>
                            <p
                                className='panel-text'
                                style={{
                                    color: typeof invoiceData?.status === 'string' && invoiceData?.status.toLowerCase().startsWith('success') ? 'green' :
                                        invoiceData?.status === '' ? 'blue' : 'red'
                                }}
                            >
                                {invoiceData?.status ? invoiceData.status : "Send to SAP"}
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {isShowRemarks && (
                <Row>
                    <Col span={24}>
                        {/* Additional UI for remarks, if required */}
                    </Col>
                </Row>
            )}
        </>
    );

    return (
        <Card bordered={false} title={'Audit Log'}>
            {/* <Button className='modLog'>Modification Log</Button> */}
            <Collapse
                activeKey={panelData?.id}
                bordered={false}
                accordion={true}
                className='mt-2 single-edit-collapse'
            >
                <Collapse.Panel
                    header={renderPanelHeader()}
                    key={panelData?.id.toString()}
                >
                    <div>
                        <LineItemEditTable
                            panelID={panelData?.id.toString()}
                            rejectionRemark={invoiceData.rejectionRemark}
                            isEdit={isEditable}
                            isRemarks={isShowRemarks}
                            disputeReasonID={selectedDisputeReason}
                            isLineItemChange={resetDisputeReason}
                        />
                    </div>
                </Collapse.Panel>
            </Collapse>
            <div className='auditLogSection'>
                <AuditLog></AuditLog>
            </div>
        </Card>
    );
};

export default ModificationLog;
